import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { AxiosProvider } from 'react-axios'
import App from './App'
import LocaleProvider from './components/LocaleProvider'
import store from './store'
import { axios, logBuildTime, setupErrorTracking } from './utils'

import './styles/app.scss'
import 'react-datepicker/dist/react-datepicker.css'

setupErrorTracking()
logBuildTime()

const root = createRoot(document.getElementById('root'))

root.render(
    <Provider store={store}>
        <AxiosProvider instance={axios}>
            <LocaleProvider>
                <App />
            </LocaleProvider>
        </AxiosProvider>
    </Provider>
)
